import state from '@/stores/users/state.js'
import mutations from '@/stores/users/mutations.js'
import actions from '@/stores/users/actions.js'

export default {
  state,
  mutations,
  actions
}
